export interface TrustpilotEmbedConfig {
  templateId: string | null
  businessUnitId: string | null
  sku: string | null
}

export function parseTrustpilotEmbed(html?: string | null): TrustpilotEmbedConfig | null {
  if (!html || !/trustpilot-widget/i.test(html))
    return null

  const businessUnitId = /data-businessunit-id\s*=\s*["']([^"']+)["']/i.exec(html)?.[1]?.trim() ?? null
  if (!businessUnitId)
    return null

  return {
    templateId: /data-template-id\s*=\s*["']([^"']+)["']/i.exec(html)?.[1]?.trim() ?? null,
    businessUnitId,
    sku: /data-sku\s*=\s*["']([^"']+)["']/i.exec(html)?.[1]?.trim() ?? null,
  }
}

export function isTrustpilotEmbed(html?: string | null): boolean {
  return !!html && /trustpilot-widget/i.test(html)
}
